import { Button, Text } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import { useTokensValues } from "../../../hooks/tokens";
import type { ExplainerCardProps } from "../types";

export const ExplainerCard = ({ ref, ...props }: ExplainerCardProps) => {
  const {
    productName,
    description,
    isActionable = false,
    isDisabled = false,
    buttonLabel = "Continue",
    className,
    ...otherProps
  } = props;

  const { authenticityToken, journeyToken } = useTokensValues();

  const classes = classNames(
    "mobius",
    "mobius-explainer-card",
    { "--is-actionable": isActionable },
    { "--is-disabled": isDisabled },
    className,
  );

  return (
    <div ref={ref} className={classes} {...otherProps}>
      <Text
        elementType="h3"
        variant="h3"
        className="mobius-explainer-card__product"
      >
        {productName}
      </Text>
      {description && (
        <Text className="mobius-explainer-card__description">
          {description}
        </Text>
      )}
      {isActionable && (
        <form
          action=""
          method="POST"
          className="mobius-explainer-card__form"
          data-testid="explainer-card-form"
        >
          <input
            type="hidden"
            name="authenticity_token"
            value={authenticityToken}
          />
          <input type="hidden" name="journey_token" value={journeyToken} />
          <Button
            type="submit"
            variant={isDisabled ? "secondary" : "primary"}
            isDisabled={isDisabled}
            className="mobius-explainer-card__button"
          >
            {buttonLabel}
          </Button>
        </form>
      )}
    </div>
  );
};

ExplainerCard.displayName = "ExplainerCard";
